export default "__VITE_PUBLIC_ASSET__c84b5aa8__"